<template>
  <div class="ds-control dsf-sc-table-design dsf-sc-biaowei" :class="getCss" @click="click">
    <img :src="'./static/img/project/tableDesign/biaoweitupian.jpg'" />
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfSCBiaowei",
  ctrlCaption: "表尾",
  mixins: [$mixins.control],
  props: {
    // 单位负责人
    dwfzr: {
      type: Boolean,
      default: true,
    },
    // 统计负责人
    tjfzr: {
      type: Boolean,
      default: true,
    },
    // 填表人
    tbr: {
      type: Boolean,
      default: true,
    },
    // 报出日期
    bcrq: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    click() {
      dsf.layer.openDialog()
    },
  },
});
</script>

<style></style>
